
let Projectcolors = {}

Projectcolors.primary = "#0078C9"
Projectcolors.secondary = "#9e0b22"
Projectcolors.white = "#fffdf0"



export default Projectcolors 